import { Injectable, signal } from '@angular/core';

export function resolveBoardPanelOverlayInset(open: boolean, pinned: boolean, width: number): number {

  return open && !pinned ? Math.max(0, width) : 0;
}

@Injectable()
export class BoardPanelLayoutState {

  private readonly _$overlayInset = signal(0);
  public readonly $overlayInset = this._$overlayInset.asReadonly();

  public setPanel(open: boolean, pinned: boolean, width: number): void {

    this._$overlayInset.set(resolveBoardPanelOverlayInset(open, pinned, width));
  }
}
